import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['radio', 'text', 'icon'];

  connect() {
    this.updateText();
    this.setupImageErrorHandling();
  }

  setupImageErrorHandling() {
    this.iconTargets.forEach((icon) => {
      icon.addEventListener('error', (e) => {
        console.warn(`Failed to load icon: ${e.target.src}`);
        icon.classList.add('d-none');
      });
    });
  }

  updateText() {
    const selectedRadio = this.radioTargets.find((radio) => radio.checked);
    
    this.textTargets.forEach((text) => {
      if (selectedRadio) {
        const value = selectedRadio.value;
        const name = text.dataset.name;
        if (name === value) {
          text.classList.remove('d-none');
        } else {
          text.classList.add('d-none');
        }
      } else {
        // Hide all text if no radio is selected
        text.classList.add('d-none');
      }
    });
  }
}
